
angular.module('trainerWebApp.resources')
  .factory('seriesTraineesResource', ['$resource', 'errorHandler', '$window', 'mtypes', function ($resource, errorHandler, $window, mtypes) {

  var TraineesResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/:seriesId/:type');

  var TraineeResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/:seriesId/trainee/:traineeId/:type');
  var TraineeResourceMM = $resource(mfConfig.courseSeriesBaseUrlSegment + '/series/:seriesId/:type/:userId');

  var BulkTraineesResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/:seriesId/:type');
  var BulkTraineesDeleteResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/:seriesId/:type/action/delete');

  var BulkTraineesByStateResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/:seriesId/:type/:state');
  var BulkCourseResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/course/:courseId/:type');
  var CourseResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/series/:seriesId/course/:courseId/reset');

  var SeriesMicroServiceResource = $resource(mfConfig.courseSeriesBaseUrlSegment + '/series/:seriesId/:action');
  var SeriesMicroServiceResourceReset = $resource(mfConfig.courseSeriesBaseUrlSegment + '/series/reset', null, { 'update': { method: 'PUT' } });
    var SeriesMicroServiceResourceUpdate = $resource(mfConfig.courseSeriesBaseUrlSegment + '/series/update', null, { 'update': { method: 'PUT' } });


  var SeriesMicroServiceTraineesByStateResource = $resource(mfConfig.courseSeriesBaseUrlSegment + '/series/:seriesId/:action/:state');
  var SeriesCourseMicroServiceResource = $resource(mfConfig.courseSeriesBaseUrlSegment + '/series/:seriesId/course/:courseId/:action');

  // Get when clicking on grid row
  TraineesResource.prototype.getAllSeriesCoursesForTrainee = function getAllSeriesCoursesForTrainee(seriesId, userId, resultCb, errorCb) {
    var hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);

    if (hasNewSeriesFeature)
      return TraineeResourceMM.query({seriesId: seriesId, userId: userId, type: 'trainee-courses'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    return TraineeResource.query({seriesId: seriesId, traineeId: userId, type: 'course-summary'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  TraineesResource.prototype.inviteSeriesTrainees = function inviteSeriesTrainees(seriesId, traineeIds, clientDatestamp, resultCb, errorCb) {
    return BulkTraineesResource.save({seriesId: seriesId, type: 'invitation'}, {traineeIds:traineeIds, clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  TraineesResource.prototype.uninviteSeriesTrainees = function uninviteSeriesTrainees(seriesId, traineeIds, resultCb, errorCb) {
    console.log('delete trainees ie uninvite them');
    return BulkTraineesDeleteResource.save({seriesId: seriesId, type: 'invitation'}, {traineeIds:traineeIds}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  TraineesResource.prototype.resetSeriesTrainees = function resetSeriesTrainees(seriesId, traineeIds, clientDatestamp, resultCb, errorCb) {
    var hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);

    if (hasNewSeriesFeature) {
      return SeriesMicroServiceResourceReset.update({traineeIds:traineeIds, seriesIds: [seriesId], clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    }

    return BulkTraineesResource.save({seriesId: seriesId, type: 'reset'}, {traineeIds:traineeIds, clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  TraineesResource.prototype.updateSeriesTrainees = function updateSeriesTrainees(seriesId, traineeIds, clientDatestamp, resultCb, errorCb) {
    return SeriesMicroServiceResourceUpdate.update({seriesIds: [seriesId], traineeIds: traineeIds, clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  TraineesResource.prototype.resetSeriesTraineesByState = function resetSeriesTrainees(seriesId, state, clientDatestamp, resultCb, errorCb) {
    var hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);

    if (state != 'missedCompletionDeadline' && state != 'failed' && state != 'passed') {
      return errorCb(new Error("Cannot reset trainees in state '" + state + "'"));
    }

    if (hasNewSeriesFeature)
      return SeriesMicroServiceTraineesByStateResource.save({seriesId: seriesId, action: 'reset', state: state}, {clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    return BulkTraineesByStateResource.save({seriesId: seriesId, type: 'reset', state: state}, {clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  TraineesResource.prototype.pokeRemindSeriesTrainees = function pokeRemindSeriesTrainees(seriesId, traineeIds, resultCb, errorCb) {
    return BulkTraineesResource.save({seriesId: seriesId, type: 'reminder'}, {traineeIds:traineeIds}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };


  TraineesResource.prototype.pokeRemindSeriesTraineesByState = function pokeRemindSeriesTraineesByState(seriesId, state, resultCb, errorCb) {
    if (state != 'invited' && state != 'inProgress') {
      return errorCb(new Error("Cannot remind trainees in state '" + state + "'"));
    }
    return BulkTraineesByStateResource.save({seriesId: seriesId, type: 'reminder', state: state}, {}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  // Reinvite Trainee to a Course
  TraineesResource.prototype.resetSeriesCourseTrainee = function resetSeriesCourseTrainee(seriesId, courseId, traineeId, clientDatestamp, resultCb, errorCb) {
    var hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);

    if (hasNewSeriesFeature)
      return SeriesCourseMicroServiceResource.save({seriesId: seriesId, courseId: courseId, action: 'reset'}, {traineeIds: [traineeId], clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    return CourseResource.save({seriesId: seriesId, courseId: courseId}, {traineeIds: [traineeId], clientDatestamp: clientDatestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  // Trainees page
  TraineesResource.prototype.traineesSetup = function traineesSetup(seriesId, resultCb, errorCb) {
    var hasNewSeriesFeature = !!~$window.mfConfig.features.indexOf(mtypes.featureEntry.newSeries);

    if (hasNewSeriesFeature)
      return SeriesMicroServiceResource.get({seriesId: seriesId, action: 'trainees'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    return TraineesResource.get({seriesId: seriesId, type: 'trainees-setup'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  TraineesResource.prototype.getAllTraineesInASeries = function getAllTraineesInASeries(seriesId, resultCb, errorCb) {
    return TraineesResource.get({seriesId: seriesId, type: 'trainee'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  // Add Trainees page
  TraineesResource.prototype.inviteSetup = function inviteSetup(id, resultCb, errorCb) {
    return BulkCourseResource.get({courseId: id, type: 'invite-setup'}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  // Add Trainees page
  TraineesResource.prototype.updateDeadline = function updateDeadline(seriesId, traineeIds, deadlineDateTimestamp, resultCb, errorCb) {
    return BulkTraineesResource.save({seriesId: seriesId, type: 'completionDeadline'}, {traineeIds:traineeIds, deadlineDateTimestamp: deadlineDateTimestamp}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  return new TraineesResource;
}]);
